module.exports = __webpack_public_path__ + "static/solutions-module-decision-40dd6d438d7a59d28172c54444e70aa9.svg";